import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RichmediaItem, RootRichmedia } from 'src/app/models/richmedia-ads';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RichmediaAdsService {
  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private http: HttpClient) { }

  getMenuSections(): Promise<{ key: string; name: string }[]> {
    const url = 'https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/menu-pulzo/menu.json';
  
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar secciones del menú');
        return res.json();
      })
      .then(data => {
        const sectionsValid = data.sections_valid;
  
        // Convertimos el objeto en un array
        return Object.entries(sectionsValid).map(([key, value]: [string, any]) => ({
          key,         // ejemplo: "bienestar"
          name: value.name // ejemplo: "Bienestar"
        }));
      });
  }

  // --- RICHMEDIA: obtener TODO el root (lo necesitamos para el PUT) ---
  getRichmediaRoot(): Promise<RootRichmedia> {
    const random = Date.now();
    const url = `https://filesstaticpulzo.s3.us-west-2.amazonaws.com/pulzo-lite/jsons/admin/richmedia.json?nocache=${random}`;
  
    return fetch(url)
      .then(res => {
        if (!res.ok) throw new Error('Error al cargar richmedia root');
        return res.json();
      });
  }
  

  saveRichmedia(data: RootRichmedia){
    //console.log('srv', `${this.baseUrl}/request?event=actualizar-richmedia`, data);
    return this.http.put<RootRichmedia>(`${this.baseUrl}/request?event=actualizar-richmedia`, data);
  }

  

}
